import { render, staticRenderFns } from "./Training.vue?vue&type=template&id=b488fdda&"
import script from "./Training.vue?vue&type=script&lang=js&"
export * from "./Training.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports